import { render } from "./Loisirs.vue?vue&type=template&id=48c60a62"
import script from "./Loisirs.vue?vue&type=script&lang=js"
export * from "./Loisirs.vue?vue&type=script&lang=js"
script.render = render

export default script